import { Icon, InputAdornment, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Controller, useFormState, useFormContext } from "react-hook-form";

// Define un TextField personalizado con los estilos deseados
const CustomStyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: theme.palette.primary.main,
    },
  },
  '& .MuiInputBase-input': {
    fontSize: '0.92rem',
  },
}));



const CustomTextField = ({
  Component = TextField,
  name,
  label,
  rules,
  helperText,
  type = "text",
  req,
  rows = 1,
  readOnly = false,
  endAdornment,
  disabled = false,
  inputLabelProps = true,
  iconoClose = false,
  multiline = false,
  startAdornment,
  size,
  ...restProps
}) => {
  const formState = useFormState();
  const { control } = useFormContext(); // Usa useFormContext para obtener control

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value, ref } }) => (
        <CustomStyledTextField
          margin="normal"
          type={type}
          onChange={onChange}
          onBlur={onBlur}
          value={value || ''}
          rows={rows}
          ref={ref}
          size={size}
          error={Boolean(formState.errors && formState.errors[name]?.message)}
          helperText={
            typeof formState.errors[name]?.message === 'string' 
              ? formState.errors[name]?.message 
              : helperText
          }
          label={label}
          variant="outlined"
          fullWidth
          required={req}
          multiline={multiline}
          disabled={disabled}
          {...restProps}
          InputProps={{
            readOnly: readOnly,
            startAdornment: startAdornment,
            endAdornment: (
              <>
                {endAdornment}
                {iconoClose && (
                  <InputAdornment position="end">
                    <Icon icon="clarity:lock-solid" />
                  </InputAdornment>
                )}
              </>
            ),
          }}
          InputLabelProps={{ shrink: inputLabelProps }}
        />
      )}
      rules={rules}
    />
  );
};

export default CustomTextField;
